import styled from "styled-components"

export const Button = styled.button`
  background: none;
  background: ${props => props.background};
  border: 0;
  border-radius: 0.5em;
  box-shadow: ${props => (props.flat ? "none" : "0 0 0.5em #333")};
  color: ${props => props.color};
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  outline: 0;
  padding: ${props => props.padding};
  text-transform: uppercase;
  transform: translate3d(0, 0, 0);
  transition: all 3s ease-in-out;
  vertical-align: middle;

  &:hover > svg {
    transform: scale(1.2);
  }
`
